<template>
    <CardRh :processando="processando" titulo="Perfis Cadastrados">
        <div class="perfil-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaPerfil" class="form-label">Pesquisar</label>
                        <input id="pesquisaPerfil" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pesquisar" />
                    </div>

                    <div class="col-12 col-lg-9 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                        <button v-if="hasPermissaoAdmin" type="button" class="btn btn-sm btn-pmes-primary"
                            title="Cadastrar" data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro">
                            <i class="fa fa-plus bi fs-2x"></i> <span>Cadastrar</span>
                        </button>
                        <Pdf :service="service" :token="token" />
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th style="max-width:120px">ID</th>
                    <th>Nome</th>
                    <th>Descricao</th>
                    <th style="min-width:150px" class="text-center" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>
        <Permissao :service="service" :modelo="dados" :modal="modal_permissao" v-if="hasPermissao" :perfis="perfis" />
        <Usuario :service="service" :modelo="modelo" :modal="modal_usuario" v-if="hasPermissao" :perfis="perfis" />
        <Cadastro :service="service" @perfil-cadastro-alterado="modeloAlterado" :modal_cadastro="modal_cadastro"
            v-if="hasPermissaoAdmin" :perfis="perfis" />
    </CardRh>
</template>

<script lang="ts">
import CardRh from "@/components/cards/ManzaCard.vue";
import PerfilService from "@/service/v1/seguranca/PerfilService";
import { Options, Vue } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { Watch, Prop } from 'vue-property-decorator';
import Permissao from "./_Permissao.vue";
import Usuario from "./_Usuarios.vue";
import Cadastro from "./_Cadastro.vue";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Pdf from "./_Pdf.vue";
import { namespace } from 'vuex-class';
const authStore = namespace('auth');

@Options({
    name: "Afastamento",
    components: { CardRh, KDataTable, Permissao, Usuario, Cadastro, Pdf },
})
export default class Afastamento extends Vue {

    @authStore.Getter
    public token!: any

    @Prop() readonly model_watch!: any
    @Prop() readonly modal_cadastro!: any
    @Prop() readonly perfis!: any

    @Watch('model_watch')
    modeloAlterado(newVal: string) {
        this.reloadDatatable = !this.reloadDatatable;
    }

    public processando = false;
    public modelo = null;
    public dados = null;
    public reloadDatatable = false;
    public config;
    public service;
    public modal_usuario;
    public modal_permissao;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    get hasPermissaoAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.refreshTable();
    }

    created() {
        this.config = { ajax: {}, columns: {}, columnDefs: {} };
        this.service = new PerfilService();

        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    search: this.search || d.search.value
                };
                return dados;
            }
        };

        this.modal_usuario = 'modal_perfil_usuario_';
        this.modal_permissao = 'modal_perfil_permissao_';
        this.config.columns = [
            { data: 'id', name: 'id' },
            { data: 'nome', name: 'nome' },
            { data: 'descricao', name: 'descricao' }
        ];
        if (this.hasPermissao) {
            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs = [
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) { buttom = buttom + ' data-' + key + '="' + val[key] + '"'; }
                        texto = texto + '<button class="btn btn-warning btn-sm" btn-usuario ' + buttom + '   data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_usuario + '"><i class="fa fa-users"></i></button>';
                        return texto;
                    },
                }
            ];
        }
    }

    public tableatualizada() {
        $('[btn-usuario]').click((btn) => {
            this.modelo = $(btn.currentTarget).data();
        });
        $('[btn-permissao]').click((btn) => {
            this.dados = $(btn.currentTarget).data();
        });
    }
}
</script>

<style scoped>
.perfil-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
